import React from 'react'
import styles from "../../styles/Streek.module.css"
const Streek = () => {
  return (
    <div className={styles.Streek}>
           
              <img
                // width="50%"
                id="github-stats-card"
               src='https://github-readme-stats.vercel.app/api?username=charchit07&count_private=true&show_icons=true'
               />
              <img                 
                src="https://github-readme-streak-stats.herokuapp.com/?user=charchit07"
                alt="charchit07"
                id="github-streak-stats"
              />
              <img
              src='https://github-readme-stats.vercel.app/api/top-langs/?username=charchit07'
              id='github-top-langs'
              />
          
          </div>
  )
}

export default Streek